import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useGeolocationStore } from "@/common/store/geolocationStore";
import { useUserStore } from "@/common/store";
import { isPageAllowed, getAlternatePage } from "@/common/utils/geoRules";

export const useGeoBlockedPage = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const blockedState = useGeolocationStore((state) => state.blockedState);
  const country = useGeolocationStore((state) => state.country);
  const currentUser = useUserStore((state) => state.currentUser);

  useEffect(() => {
    if (isPageAllowed(pathname, country, blockedState)) {
      return;
    }

    if (currentUser === undefined || currentUser?.verified) {
      return;
    }

    const alternatePage = getAlternatePage(pathname, country, blockedState);

    if (!alternatePage) {
      return;
    }

    if (alternatePage.startsWith("https://")) {
      window.location.replace(alternatePage);
      return;
    }

    navigate(alternatePage, { replace: true });
  }, [pathname, blockedState, country, currentUser, navigate]);
};
